module.exports = __webpack_public_path__ + "assets/img/classify_bg.aa343678.png";